import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialCandidateSearchSlice } from './candidate-search.slice';
import { environment } from 'src/environments/environment';
import { CandidateSearch } from 'src/app/recruiting/locums-margin-calculator/models/candidate-search.models';

export const CandidateSearchStore = signalStore(
    { providedIn: 'root' },
    withState(initialCandidateSearchSlice),
    withMethods((store) => {
        return {
            setCandidates(candidates: CandidateSearch[]) {
                if (!Array.isArray(candidates)) {
                    return;
                }
                patchState(store, { candidates });
            },

            setSelectedCandidate(candidate: CandidateSearch) {
                if (!candidate) {
                    return;
                }
                patchState(store, {
                    selectedCandidate: candidate,
                    isCandidateSelected: true
                });
            },

            clearSelectedCandidate() {
                patchState(store, {
                    selectedCandidate: undefined,
                    isCandidateSelected: false
                });
            }
        };
    }),
    environment.storeWithDevTools('locums-margin-calculator-candidate-search-store')
);
